export enum PhoneConfirmStepsEnum {
  START = 0,
  CODE_SEND = 1,
  CODE_VERIFIED = 2,
}
